import copyToClipboard from 'copy-to-clipboard';
import toast from 'react-hot-toast';

const copyText = async (text, successMessage = 'Copiado') => {
  if (!text) return false;

  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      toast.success(successMessage);
      return true;
    } catch {
      // segue para o fallback
    }
  }

  try {
    if (copyToClipboard(text, { format: 'text/plain' })) {
      toast.success(successMessage);
      return true;
    }
  } catch {
    // segue para o último fallback
  }

  try {
    window.prompt('Copie com Ctrl+C / Cmd+C:', text);
    return true;
  } catch {
    toast.error('Não foi possível copiar');
    return false;
  }
};

export default copyText;
